import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  select: {
    width: "100%",
    backgroundColor: theme.palette.white.main,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.type === "light"
          ? [theme.palette.secondary.tint100, "!important"]
          : [theme.palette.background.paper, "!important"],
    },
  },
  styleMenuItem: {
    display: "block",
  },
  MenuItemText: {
    display: "inline-flex",
  },
  MenuItemImg: {
    display: "inline-flex",
    width: "24px",
    height: "24px",
    margin: "-8px 5px",
  },
  MenuItemTextCoin: {
    color: theme.palette.secondary.tint40,
    display: "inline-flex",
  },
  placeholder: {
    width: "100%",
    margin: "0px 8px",
    color: theme.palette.secondary.tint40,
  },
}));
